import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CardSize } from '@freelancer/ui/card';
import { HeadingColor, HeadingSize, HeadingType } from '@freelancer/ui/heading';
import * as Rx from 'rxjs';
import { HireMeUser } from '../hire-me.component';

@Component({
  template: `
    <fl-card
      *ngIf="(hireMeUser$ | async) as hireMeUser"
      class="DarkCard"
      [edgeToEdge]="true"
      [size]="CardSize.SMALL"
    >
      <fl-heading
        class="CardHeading PaddedSection"
        i18n="User Profile Hire Me Component Heading"
        [color]="HeadingColor.LIGHT"
        [headingType]="HeadingType.H2"
        [size]="HeadingSize.XXSMALL"
      >
        Hire for Work Opportunity
      </fl-heading>

      <fl-bit class="PaddedSection">
        <app-hire-me
          defaultMessage="Hi {{
            hireMeUser.profileUserDisplayName
          }}, I noticed your profile and would like to offer you my project. We can discuss any details over chat."
          i18n-defaultMessage="User Profile Hire Me module default message"
          [hireMeUser]="hireMeUser"
          [flTrackingSection]="'UserProfileHireMeModal'"
        ></app-hire-me>
      </fl-bit>
    </fl-card>
  `,
  styleUrls: ['./hire-me-webapp-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HireMeWebappModalComponent {
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  HeadingSize = HeadingSize;
  CardSize = CardSize;
  @Input() hireMeUser$: Rx.Observable<HireMeUser>;
}
